import { Link as LinkIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Empty state component for links
 * Displays a message when no links are available
 *
 * How it works:
 * 1. Renders a centered empty state with an icon and message
 * 2. Uses internationalization (i18n) for translating the empty state message
 * 3. Maintains consistent styling with other empty states in the application
 *
 * Key features:
 * - Localized text through i18n
 * - Consistent styling with other empty states
 * - Clear visual indication with appropriate icon
 * - Responsive layout that works at different screen sizes
 *
 * Context:
 * This component is displayed by LinkList when there are no links
 * to display in the current chat. It follows the same pattern as
 * MediaAttachmentEmpty and FileAttachmentEmpty for consistency.
 */
export default function LinkEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-2 p-4">
      <LinkIcon className="size-8 text-muted-foreground" />
      <p className="text-center text-sm text-muted-foreground">
        {t("chatDetailsTabs.no_links")}
      </p>
    </div>
  );
}
